const tabs = [
    { icon: 'fa fa-pause', tabName: 'Pending', modal: false }, // 0
    { icon: 'fa fa-times', tabName: 'Reject Bike', modal: true }, // 1 - deleted on 4 Feb 2025 (not used by agents)
    { icon: 'fa fa-user', tabName: 'Assign To Me', modal: false }, // 2
    {
        icon: 'fa fa-motorcycle', tabName: 'Find Reference Bike', modal: false, link: true,
    }, // 3
    { icon: 'fa fa-pound-sign', tabName: 'Value Bike', modal: true }, // 4
    { icon: 'fa fa-copy', tabName: 'Duplicate', modal: false }, // 5
    { icon: 'fa fa-pound-sign', tabName: 'Send Valuation', modal: false }, // 6
    { icon: 'fa fa-pound-sign', tabName: 'Update Valuation', modal: true }, // 7
    { icon: 'fa fa-smile', tabName: 'In Progress', modal: false }, // 8
    { icon: 'fa fa-notes-medical', tabName: 'Start Blemish Report', modal: true }, // 9
    { icon: 'fa fa-check', tabName: 'Customer Accepted', modal: false }, // 10
    { icon: 'fa fa-times', tabName: 'Customer Declined', modal: true }, // 11
    { icon: 'fa fa-at', tabName: 'Send Email', modal: true }, // 12
    {
        icon: 'fa fa-cog', tabName: 'HPI Check', modal: true, disabled: false,
    }, // 13
    { icon: 'fa fa-cog', tabName: 'Redo HPI Check', modal: true }, // 14
    { icon: 'fa fa-motorcycle', tabName: 'Arrange Collection', modal: false }, // 15
    { icon: 'fa fa-at', tabName: 'Book Collection', modal: true }, // 16
    { icon: 'fa fa-mobile-alt', tabName: 'Send SMS', modal: true }, // 17
    { icon: 'fa fa-pencil-alt', tabName: 'Update Booking', modal: true }, // 18
    { icon: 'fa fa-ban', tabName: 'Cancel Booking', modal: false }, // 19
    { icon: 'fa fa-at', tabName: 'Re-Book Collection', modal: false }, // 20
    { icon: 'fa fa-ban', tabName: 'Cancel Collection', modal: true }, // 21
    { icon: 'fa fa-ban', tabName: 'Do not Contact', modal: false }, // 22
    { icon: 'fa fa-pound-sign', tabName: 'Value Bike (Trade)', modal: true }, // 23
    { icon: 'fa fa-times', tabName: 'Bike In Poor Condition', modal: false }, // 24
    { icon: 'fa fa-times', tabName: 'Bike Too Old', modal: false }, // 25
    { icon: 'fa fa-times', tabName: 'Bike High Mileage', modal: false }, // 26

    { icon: 'fa fa-pound-sign', tabName: 'Update Valuation (Trade)', modal: true }, // 27
    { icon: 'fa fa-pound-sign', tabName: 'Send Valuation (Trade)', modal: false }, // 28
    { icon: 'fa fa-times', tabName: 'Customer Declined (Trade)', modal: false }, // 29
    { icon: 'fa fa-smile', tabName: 'In Progress (Trade)', modal: false }, // 30
    { icon: 'fa fa-smile', tabName: 'Customer Accepted (Trade)', modal: false }, // 31
    { icon: 'fa fa-motorcycle', tabName: 'Arrange Collection (Trade)', modal: false }, // 32
    { icon: 'fa fa-at', tabName: 'Book Collection (Trade)', modal: false }, // 33
    { icon: 'fa fa-times', tabName: 'Bike High Mileage', modal: true }, // 34
    { icon: 'fa fa-ban', tabName: 'Scrap', modal: false }, // 35
    { icon: 'fa fa-motorcycle', tabName: 'Pending (Trade)', modal: false }, // 36
    { icon: 'fa fa-pound-sign', tabName: 'Customer Wants Too Much (Trade)', modal: false }, // 37
    { icon: 'fa fa-pound-sign', tabName: 'Customer Already Sold (Trade)', modal: false }, // 38
    { icon: 'fa times', tabName: 'Tried To Call - No Answer (Trade)', modal: false }, // 39
    { icon: 'fa fa-times', tabName: 'Not Selling (Trade)', modal: false }, // 40
    { icon: 'fa fa-times', tabName: 'Poor Condition (Trade)', modal: false }, // 41
    { icon: 'fa fa-times', tabName: 'We Do Not Want (Trade)', modal: false }, // 42
    { icon: 'fa fa-times', tabName: 'Cancel Collection (Trade)', modal: true }, // 43

    { icon: 'fa fa-times', tabName: 'Bike In Poor Condition (Trade)', modal: false }, // 44
    { icon: 'fa fa-times', tabName: 'Bike Too Old (Trade)', modal: false }, // 45
    { icon: 'fa fa-times', tabName: 'Bike High Mileage (Trade)', modal: false }, // 46

    { icon: 'fa fa-times', tabName: 'Already Booked In', modal: false }, // 47 5fb2920966b3d64849b0b609
    { icon: 'fa fa-times', tabName: 'On No Buy List', modal: false }, // 48 5beabf6166676f89160edfc3
    { icon: 'fa fa-times', tabName: 'Not Bought - Price', modal: false }, // 49 5cc191f25f7d1c0dfbc10f84
    { icon: 'fa fa-times', tabName: 'Not Bought - Poor Condition', modal: false }, // 50 5cc191ff5f7d1c0dfbc10f85
    { icon: 'fa fa-times', tabName: 'HPI Failed', modal: false }, // 51 5beabf6166676f89160edfc1
    { icon: 'fa fa-times', tabName: 'We Dont Want', modal: false }, // 52 5beabe6d66676f89160edd7f
    { icon: 'fa fa-pause', tabName: 'Request More Information', modal: false }, // 53 5beabfe7f25bf5f49685abfa
    { icon: 'fa fa-pause', tabName: 'Duplicate (Trade)', modal: false }, // 54 5fd27dc61dc278430e324b21
    { icon: 'fa fa-pause', tabName: 'Request More Info (Trade)', modal: false }, // 55 5fe25d1a740d6a6ca7acedb8
    { icon: 'fa fa-pic', tabName: 'Request More Info On Bike', modal: false }, // 56 60487c3c70154bdc1742b58f
    { icon: 'fa fa-pic', tabName: 'More Info On Bike Received', modal: false }, // 57 6048a73470154bdc1742b591
    { icon: 'fa fa-pic', tabName: 'Re-Valuation Required', modal: false }, // 58 61d69a6e8e49c7dcf2635303
    { icon: 'fa fa-pic', tabName: 'Bring Bike Back Into Stock', modal: false }, // 59 62458a3df509003dd6dc46af
    { icon: 'fa fa-pic', tabName: 'Bought', modal: false }, // 60 5c8784c947f99d83281b350d
    { icon: 'fa fa-pic', tabName: 'Trade', modal: false }, // 61 5f8574a3d88a9007b68aa732
    { icon: 'fa fa-pic', tabName: 'Scrap', modal: false }, // 62 5beabf6166676f89160edfc3
    { icon: 'fa fa-pic', tabName: 'Pending (Scrap)', modal: false }, // 63 5beabf6166676f89160edfc3
    { icon: 'fa fa-pound-sign', tabName: 'Manage Delivery Requested', modal: false }, // 64 65cb992434ed8e1cf4b3e9b4
    { icon: 'fa fa-pound-sign', tabName: 'Manage Delivery Requested (Trade)', modal: false }, // 65 65cb992434ed8e1cf4b3e9b4
    { icon: 'fa fa-pound-sign', tabName: 'Twilio Deal', modal: false }, // 66 65ce15630e760ac5454a4c10
    { icon: 'fa fa-pound-sign', tabName: 'Twilio Deal (Trade)', modal: false }, // 67 65ce15420e760ac5454a4c0f
    // 60422adafdfc98e8de82c458
];

export const status_tabs = {
    '5beabe7d66676f89160edd80': { // we want
        tabs: [tabs[2], tabs[17], tabs[12], tabs[22]],
        button_style: 'btnLeadNew Blue',
    },
    '5beabfe7f25bf5f49685abfa': { // missing information
        tabs: [tabs[0], tabs[2], tabs[22]],
        button_style: 'btnLeadNew Blue',
    },
    '5beabfe7f25bf5f49685abfb': { // pending
        tabs: [tabs[53], tabs[61], tabs[62], tabs[3], tabs[4], tabs[9], tabs[11], tabs[2], tabs[47]],
        button_style: 'btnLeadNew Blue',
    },
    '5c349213b01ff686c64b1dd4': { // priced
        tabs: [tabs[9], tabs[3], tabs[11], tabs[6], tabs[7], tabs[2], tabs[17], tabs[12], tabs[47], tabs[22], tabs[24], tabs[52]],
        // tabs: [tabs[9], tabs[3], tabs[11], tabs[6], tabs[7], tabs[13], tabs[2], tabs[17], tabs[12], tabs[5]],
        button_style: 'btnLeadNew Blue',
    },
    '5beabfe7f25bf5f49685abfc': { // price given
        tabs: [tabs[8], tabs[3], tabs[7], tabs[9], tabs[10], tabs[11], tabs[2], tabs[17], tabs[12], tabs[47], tabs[22], tabs[24]],
        button_style: 'btnLeadNew Blue',
    },
    '5bf2b498f83650911c3e3e80': { // in progress
        tabs: [tabs[7], tabs[3], tabs[9], tabs[10], tabs[11], tabs[2], tabs[17], tabs[12], tabs[47], tabs[51], tabs[22], tabs[24]],
        button_style: 'btnLeadNew Orange',
    },
    '60422adafdfc98e8de82c458': { // Delivery Requested (Trade)
        tabs: [tabs[65], tabs[67], tabs[27], tabs[3], tabs[9], tabs[30], tabs[13], tabs[27], tabs[31], tabs[29], tabs[2], tabs[37], tabs[38], tabs[39], tabs[40], tabs[41], tabs[22], tabs[54]],
        button_style: 'btnLeadNew Orange',
    },
    '65cb992434ed8e1cf4b3e9b4': { // Manage Delivery Requested
        tabs: [tabs[66], tabs[7], tabs[21], tabs[3], tabs[9], tabs[10], tabs[11], tabs[2], tabs[17], tabs[12], tabs[47], tabs[51], tabs[22]],
        button_style: 'btnLeadNew Orange',
    },
    '65ce15630e760ac5454a4c10': { // Twilio Deal
        tabs: [tabs[7], tabs[21], tabs[3], tabs[9], tabs[10], tabs[11], tabs[2], tabs[17], tabs[12], tabs[47], tabs[51], tabs[22]],
        button_style: 'btnLeadNew Orange',
    },
    '5fbf6505e4073f744bae3a28': { // Delivery Requested
        tabs: [tabs[64], tabs[66], tabs[7], tabs[21], tabs[3], tabs[9], tabs[10], tabs[11], tabs[2], tabs[17], tabs[12], tabs[47], tabs[51], tabs[22]],
        button_style: 'btnLeadNew Orange',
    },
    '65ce15420e760ac5454a4c0f': { // Twilio Deal (trade)
        tabs: [tabs[27], tabs[3], tabs[9], tabs[30], tabs[13], tabs[27], tabs[31], tabs[29], tabs[2], tabs[37], tabs[38], tabs[39], tabs[40], tabs[41], tabs[22], tabs[54]],
        button_style: 'btnLeadNew Orange',
    },
    '65cbc69bb3eef4411a1de6c4': { // Manage Delivery Requested (trade)
        tabs: [tabs[67], tabs[27], tabs[3], tabs[9], tabs[30], tabs[13], tabs[27], tabs[31], tabs[29], tabs[2], tabs[37], tabs[38], tabs[39], tabs[40], tabs[41], tabs[22], tabs[54]],
        button_style: 'btnLeadNew Orange',
    },
    '5beac00ef25bf5f49685abfd': { // customer accepted
        tabs: [tabs[7], tabs[15], tabs[3], tabs[9], tabs[13], tabs[11], tabs[2], tabs[17], tabs[12], tabs[51], tabs[22], tabs[24]],
        button_style: 'btnLeadNew Orange',
    },
    '5beac00ef25bf5f49685abfe': { // customer rejected
        tabs: [tabs[0], tabs[7], tabs[3], tabs[2], tabs[17], tabs[12], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beac062f25bf5f49685abff': { // Customer Cancelled - Already Sold Bike
        tabs: [tabs[0], tabs[2], tabs[3], tabs[17], tabs[12], tabs[13], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beac062f25bf5f49685ac00': { // Customer Cancelled - Offered Better Price Elsewhere
        tabs: [tabs[0], tabs[3], tabs[2], tabs[17], tabs[12], tabs[13], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beac063f25bf5f49685ac01': { // Customer Wants Too Much
        tabs: [tabs[0], tabs[8], tabs[3], tabs[2], tabs[17], tabs[12], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beac063f25bf5f49685ac02': { // Customer Changed Mind
        tabs: [tabs[0], tabs[8], tabs[3], tabs[2], tabs[17], tabs[12], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beac063f25bf5f49685ac03': { // Tried to Call - No Answer
        tabs: [tabs[0], tabs[8], tabs[3], tabs[2], tabs[17], tabs[12], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beac063f25bf5f49685ac04': { // Tried to Call - Wrong Number
        tabs: [tabs[0], tabs[2], tabs[3], tabs[17], tabs[12], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5c4837e08109b9f96e847a49': { // arrange Collection
        tabs: [tabs[3], tabs[7], tabs[21], tabs[2], tabs[13], tabs[17], tabs[12], tabs[22]],
        button_style: 'btnLeadNew Orange',
    },
    '5c8615197e203773e8886802': { // transport arranged
        tabs: [tabs[3], tabs[7], tabs[21], tabs[13], tabs[2], tabs[17], tabs[12], tabs[22]],
        button_style: 'btnLeadNew Orange',
    },
    '5c87838c47f99d83281b350b': { // collection confirmed - is not used!!!
        tabs: [tabs[0], tabs[7], tabs[21], tabs[3], tabs[18], tabs[19], tabs[2], tabs[17], tabs[12], tabs[13], tabs[49], tabs[50], tabs[51], tabs[22]],
        button_style: 'btnLeadNew Orange',
    },
    '5c87845747f99d83281b350c': { // collection canceled
        tabs: [tabs[0], tabs[15], tabs[3], tabs[11], tabs[2], tabs[17], tabs[12], tabs[13], tabs[51], tabs[22]],
        button_style: 'btnLeadNew Orange',
    },
    '5c87850f47f99d83281b350e': { // driver cancelled
        tabs: [tabs[0], tabs[2], tabs[3], tabs[17], tabs[12], tabs[13], tabs[22]],
        button_style: 'btnLeadNew Orange',
    },
    '5eb1583e5467207529c3416f': { // bought Dans
        tabs: [tabs[3], tabs[13]],
        button_style: 'btnLeadNew Green',
    },

    '5c8784c947f99d83281b350d': { // bought
        tabs: [tabs[3], tabs[13]],
        button_style: 'btnLeadNew Green',
    },

    '64d5096984e3cb61676f6172': { // bought (trade)
        tabs: [tabs[3], tabs[13]],
        button_style: 'btnLeadNew Green',
    },
    '5cc191f25f7d1c0dfbc10f84': { // Not Bought - Price
        tabs: [tabs[0], tabs[3], tabs[2], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5cc191ff5f7d1c0dfbc10f85': { // Not Bought - Poor Condition
        tabs: [tabs[0], tabs[3], tabs[2], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '64d5f35a5c42d474915f9d7b': { // Not Bought - Price (trade)
        tabs: [tabs[0], tabs[3], tabs[2], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '64d5f3395c42d474915f9d7a': { // Not Bought - Poor Condition (trade)
        tabs: [tabs[0], tabs[3], tabs[2], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beabe6d66676f89160edd7f': { // We Do not Want
        tabs: [tabs[0], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '656f2b36be1ab29fc3eff18c': { // We Do not Want
        tabs: [tabs[0], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beabef666676f89160edfbf': { // Mileage too high
        tabs: [tabs[0], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beabf6166676f89160edfc0': { // Bike too old
        tabs: [tabs[0], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beabf6166676f89160edfc1': { // HPI Failure
        tabs: [tabs[0], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beabf6166676f89160edfc2': { // Bike in poor condition
        tabs: [tabs[0], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beabf6166676f89160edfc3': { // Bike thats on the no buy list
        tabs: [tabs[0], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beabf6166676f89160edfc4': { // Too many in stock
        tabs: [tabs[0], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beabf6166676f89160edfc5': { // Track / Race Bike
        tabs: [tabs[0], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beabf6166676f89160edfc6': { // Wrong Location
        tabs: [tabs[0], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beabf6166676f89160edfc7': { // Damaged Bike
        tabs: [tabs[0], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5beabf6166676f89160edfc8': { // More Information Needed
        tabs: [tabs[0], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5cc1930a5f7d1c0dfbc10f86': { // Sold to Dealership
        tabs: [],
        button_style: 'btnLeadNew Red',
    },
    '5cc193125f7d1c0dfbc10f87': { // Out of Price Range
        tabs: [tabs[12], tabs[17], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5cc193225f7d1c0dfbc10f88': { // Mechanical Failure
        tabs: [tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5cc193275f7d1c0dfbc10f89': { // Valuation Expired
        tabs: [tabs[3], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5cc1932d5f7d1c0dfbc10f8a': { // Dead
        tabs: [tabs[3], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5cc1a18319c64e49ff8b13d8': { // Do Not Contact
        tabs: [tabs[3]],
        button_style: 'btnLeadNew Red',
    },
    '5d5ba6ffebd1ef35d423ee2f': { // Duplicate
        tabs: [tabs[3], tabs[22]], // tabs[4], tabs[7], tabs[23], tabs[27],
        button_style: 'btnLeadNew Blue',
    },
    '5f7f248cf0c43201c2a7192c': { // Trade We Dont Want
        tabs: [tabs[36], tabs[22], tabs[3]],
        button_style: 'btnLeadNew Blue',
    },
    '5f8574a3d88a9007b68aa732': { // Pending Trade
        tabs: [tabs[0], tabs[55], tabs[62], tabs[3], tabs[23], tabs[9], tabs[13], tabs[22]],
        button_style: 'btnLeadNew Blue',

    },
    '6447d613e4498f81aed6d96f': { // Pending Trade
        tabs: [tabs[36], tabs[3]],
        button_style: 'btnLeadNew Blue',

    },
    '5f8578e3d88a9007b68aa737': { // Priced Trade
        tabs: [tabs[3], tabs[9], tabs[28], tabs[13], tabs[29], tabs[27], tabs[2], tabs[37], tabs[22], tabs[54]],
        button_style: 'btnLeadNew Blue',

    },
    '5f8574aed88a9007b68aa733': { // Price Given Trade
        tabs: [tabs[3], tabs[9], tabs[30], tabs[27], tabs[31], tabs[29], tabs[2], tabs[37], tabs[38], tabs[39], tabs[40], tabs[41], tabs[22], tabs[54]],
        button_style: 'btnLeadNew Blue',
    },
    '5f85823bd88a9007b68aa73a': { // In Progress (Trade);
        tabs: [tabs[3], tabs[9], tabs[27], tabs[31], tabs[29], tabs[2], tabs[37], tabs[38], tabs[39], tabs[40], tabs[41], tabs[22], tabs[54]],
        button_style: 'btnLeadNew Blue',
    },
    '5f858198d88a9007b68aa738': { // Customer Accepted Trade
        tabs: [tabs[3], tabs[9], tabs[32], tabs[13], tabs[2], tabs[22]],
        button_style: 'btnLeadNew Orange',

    },
    '5f8582b8d88a9007b68aa73b': { // Customer Declined Trade
        tabs: [tabs[3], tabs[30], tabs[27], tabs[31], tabs[2], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5f8574fcd88a9007b68aa736': { // Arrange Collection Trade
        tabs: [tabs[3], tabs[22], tabs[43], tabs[13]],
        button_style: 'btnLeadNew Orange',
    },
    '5f858829d88a9007b68aa73c': { // Collection cancelled Trade
        tabs: [tabs[3], tabs[32], tabs[22], tabs[13]],
        button_style: 'btnLeadNew Orange',
    },
    '5f8574e3d88a9007b68aa735': { // Collection Arranged (Trade)
        tabs: [tabs[3], tabs[43], tabs[49], tabs[50], tabs[13]],
        button_style: 'btnLeadNew Orange',

    },
    '5f85820bd88a9007b68aa739': { // Transport Arranged
        tabs: [tabs[3], tabs[21], tabs[13], tabs[2], tabs[17], tabs[12], tabs[13], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5f8574ced88a9007b68aa734': { // Scrap Bike
        tabs: [tabs[3], tabs[36]],
        button_style: 'btnLeadNew Red',
    },
    '5f85a3ead88a9007b68aa73d': { // Customer Wants too much
        tabs: [tabs[0], tabs[3], tabs[36]],
        button_style: 'btnLeadNew Red',
    },
    '5f885dc8d88a9007b68aa73f': { // Customer Already Sold
        tabs: [tabs[3], tabs[36]],
        button_style: 'btnLeadNew Red',
    },
    '5f886009d88a9007b68aa740': { // Tried to call No Answer (Trade)
        tabs: [tabs[3], tabs[36]],
        button_style: 'btnLeadNew Red',
    },
    '5f886198d88a9007b68aa741': { // Not Selling (Trade)
        tabs: [tabs[3], tabs[36]],
        button_style: 'btnLeadNew Red',
    },
    '5f8863f1d88a9007b68aa742': { // Poor Condition (Trade)
        tabs: [tabs[3], tabs[36]],
        button_style: 'btnLeadNew Red',
    },

    '5f92fded338def1a9607ae36': { // On No Buy List
        tabs: [tabs[3], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5f92fb12338def1a9607ae34': { // Bike High Mileage (Trade)
        tabs: [tabs[3], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5f92fafd338def1a9607ae33': { // Bike Too Old (Trade)
        tabs: [tabs[3], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5fb2920966b3d64849b0b609': {
        tabs: [tabs[3], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5fd27dc61dc278430e324b21': {
        tabs: [tabs[3], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Red',
    },
    '5fe25d1a740d6a6ca7acedb8': {
        tabs: [tabs[3], tabs[36], tabs[22]],
        button_style: 'btnLeadNew Blue',
    },
    '60487c3c70154bdc1742b58f': {
        tabs: [],
        button_style: 'btnLeadNew Blue',
    },
    '6048a73470154bdc1742b591': {
        tabs: [],
        button_style: 'btnLeadNew Blue',
    },
    '616976d5aad9ab9a0b148910': {
        tabs: [tabs[10], tabs[3]],
        button_style: 'btnLeadNew Blue',
    },
    '61a1e03d7338e121dcfa2a3e': {
        tabs: [tabs[8], tabs[3], tabs[7], tabs[9], tabs[10], tabs[11], tabs[2], tabs[17], tabs[12], tabs[47], tabs[22], tabs[24]],
        button_style: 'btnLeadNew Blue',
    },
    '61a1e11f7338e121dcfa2a40': {
        tabs: [tabs[0], tabs[3]],
        button_style: 'btnLeadNew Blue',
    },
    '61d69a6e8e49c7dcf2635303': {
        tabs: [tabs[8], tabs[3], tabs[7], tabs[9], tabs[10], tabs[11], tabs[2], tabs[17], tabs[12], tabs[47], tabs[22], tabs[24]],
        button_style: 'btnLeadNew Blue',
    },
    '62458a3df509003dd6dc46af': {
        tabs: [tabs[3], tabs[60]],
        button_style: 'btnLeadNew Blue',
    },
    '6452516d725e6b533a95d770': {
        tabs: [tabs[3], tabs[36]],
        button_style: 'btnLeadNew Blue',
    },
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/status_tab_statics.js